export const adventureIdsForBetaReleaseDepartureSignOffs = [
  '4e159bf7-7466-4b51-b399-ea441b5753a2', // AR1
  'db2f6547-1a74-4fb9-9958-8b5d324a8749', // EG1
  'fe62e715-0415-430b-ae0e-1b9fa9a93cb3', // JP2
  '3912da4b-ba22-4c93-89d7-58434fd79731', // LK1
  '2bfe972f-b5a7-4eac-a84e-7eb6c12f1d2a', // MA2
];
